export const paths = {
  any: '*',
  dashboard: '/dashboard',
  documents: {
    root: '/documents',
    askAi: '/documents/ask-ai',
    preview: '/documents/preview/:documentId',
    viewer: '/documents/document/:documentId',
    // Child routes (relative to /documents)
    children: {
      preview: 'preview/:documentId',
      document: 'document/:documentId',
    },
  },
  login: '/login',
  savings: '/savings',
  services: '/services',
  locations: '/locations',
  upcomingEvents: '/upcoming-events',
  chat: '/chat',
  yourTeam: '/your-team',
  account: '/account',
  billing: '/billing',
  vendors: '/vendors',
  about: '/about',
  reports: '/reports',
  subsidiaryOrganization: '/subsidiary-organization',
  tickets: {
    employee: {
      any: '/:orgId/tickets/*',
      root: '/:orgId/tickets',
      details: '/:orgId/tickets/:ticketId',
      children: {
        details: ':ticketId',
      },
    },
    client: {
      root: '/tickets',
    },
  },
  help: '/help',
  billPay: '/bill-pay',
  contractTerms: '/contract-terms',
} as const;
